import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';
import { GestionTareaRepository, GuardarGestionTareaRequest } from 'src/app/domain/service/gestion-tarea/gestion-tarea-repository';
import { GestionTarea } from 'src/app/domain/model/gestion-tarea/gestion-tarea';

/**
 * Adaptador HTTP: HttpGestionTareaRepository
 *
 * Implementa el puerto GestionTareaRepository para comunicación HTTP con backend.
 * Realiza llamadas REST al backend Spring Boot (GestionTareaController).
 *
 * Arquitectura Hexagonal:
 * - Este adaptador está en infraestructura
 * - Implementa el puerto GestionTareaRepository del dominio
 *
 * Backend: 580-girop_servicios-ms (puerto 8080)
 * Base URL: /api/servicios/gestiones-tareas
 *
 * @author Sura - Migración GWT a Spring Boot
 */
@Injectable({ providedIn: 'root' })
export class HttpGestionTareaRepository implements GestionTareaRepository {

  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.backend.baseUrl}/servicios/gestiones-tareas`;

  // === Historial de Gestiones ===

  /**
   * Consulta el historial de gestiones para un detalle de orden de servicio.
   *
   * GET /api/servicios/gestiones-tareas/historial/{nmconsecutivo}
   */
  async consultarHistorialGestiones(
    nmconsecutivoDetalle: number
  ): Promise<GestionTarea[]> {
    const result = await firstValueFrom(
      this.http.get<GestionTarea[]>(`${this.baseUrl}/historial/${nmconsecutivoDetalle}`)
    );
    console.log('[HttpGestionTarea] Historial gestiones - registros:', result.length);
    return result;
  }

  // === Ingresar Gestión ===

  /**
   * Guarda una gestión de tarea para múltiples órdenes.
   *
   * POST /api/servicios/gestiones-tareas
   *
   * Legacy: CallManagementActivity.ingresarGestion(), CallsManagementHandler.saveOrUpdateCalls()
   */
  async guardarGestiones(
    request: GuardarGestionTareaRequest
  ): Promise<{ exito: boolean; mensaje?: string }> {
    try {
      const result = await firstValueFrom(
        this.http.post<{ exito: boolean; mensaje?: string }>(this.baseUrl, request)
      );
      return result;
    } catch (error) {
      console.error('[HttpGestionTarea] Error guardando gestión:', error);
      return {
        exito: false,
        mensaje: error instanceof Error ? error.message : 'Error al guardar la gestión'
      };
    }
  }
}
